function Directive() {
  return {
    restrict: 'E',
    replace: true,
    template: `<div class="loading">
    <i class="icon"></i>
</div>
    `
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/loading/index.js